import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Grid,
} from "antd";
import "./dashboard.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { getDashboardSummary } from "../../redux-toolkit/slices/dashbordSlice";
import { Button } from "react-bootstrap";



const { useBreakpoint } = Grid;

export default function KarmicDashboard() {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const localUserObj: any = getLocalStorageData("localUser");

  const dashboardSummary = useSelector(getDashboardSummary);

  const summaryCards = [
    { title: "Sponsors", value: `${dashboardSummary?.totalCredits ?? 0}`, color: "text-dark" },
    { title: "Organizations", value: `${dashboardSummary?.totalDebits ?? 0}`, color: "text-dark" },
    { title: "Active Projects", value: `${dashboardSummary?.netKarma ?? 0}`, color: "text-dark" },
    { title: "Total Allocated", value: `₹${dashboardSummary?.totalTokens ?? 0}`, color: "text-dark" },
  ];

  return (
    <div className="bg-white px-3 rounded">
      <div className="d-flex justify-content-between">
        <div>
          <h2 className="pt-3 text-accent fw-bold mb-0 text-start">Dashboard</h2>
          <p className="text-muted text-start fs-6">Overview of funds, audits, projects, cohorts, patents</p>
        </div>
        <div className="d-flex">
          <div className="d-flex px-2 align-items-center mt-1">
            <Button
              variant="light"
              className="d-flex align-items-center me-0 text-nowrap bg-white text-muted"
            // onClick={() => {
            //     setActionType(ACTION_TYPE.ADD_ACTION);
            // }}
            >
              Export CSV
            </Button>
          </div>
          <div className="d-flex px-2 align-items-center mt-1">
            <Button
              className="d-flex align-items-center me-0 text-nowrap bg-accent"
            // onClick={() => {
            //     setActionType(ACTION_TYPE.ADD_ACTION);
            // }}
            >
              Export JSON
            </Button>
          </div>
        </div>
      </div>

      {/* {
        ? (
          <Loading />
        ) : null} */}
      {screens.lg ? (
        <div
          style={{
            display: "flex",
            gap: "16px",
            overflowX: "auto",
            paddingBottom: "10px",
          }}
          className="mb-4"
        >
          {summaryCards.map((card, index) => (
            <Card
              key={index}
              bordered
              hoverable
              className="text-start shadow-sm rounded"
              style={{ minWidth: 180 }}
              bodyStyle={{ padding: "10px 12px" }}
            >
              <h6 style={{ marginBottom: "6px" }}>{card.title}</h6>
              <p className={`fw-bold ${card.color} fs-4 mb-0`}>{card.value}</p>
            </Card>
          ))}
        </div>
      ) : (
        <Row gutter={[16, 16]} justify="center">
          {summaryCards.map((card, index) => (
            <Col key={index} xs={24} sm={12} md={8}>
              <Card
                bordered
                hoverable
                className="text-start shadow-sm rounded"
                bodyStyle={{ padding: "10px 12px" }}
              >
                <h6 style={{ marginBottom: "6px" }}>{card.title}</h6>
                <p className={`fw-bold ${card.color} fs-4 mb-0`}>{card.value}</p>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <div className="mb-4 w-full">
        <p className="pt-3 text-dark fw-semibold mb-0 text-start fs-4">Alerts & Due Items</p>
      </div>
    </div>
  );
}


